<template>
    <div class="linked-question-modal" >
        <TitleBaseBox :title="data.title" :noButton="true" @close="close"
        class="linked-question-box">
            <AssociateQuery :modalData="data" :isCorrelateModal="true" />
            <RelationQuesBar :data="data" :currentLang="currentLang" @initCurrPage="initCurrPage" @getBatchQuestionList="getBatchQuestionList" @change="reqDataChange"/>
            <Table
                :curPage="curPage"
                :config="tableConfig"
                :dataset="tableData"
                :total="standTotal"
                @columnClick="tableColumnClick"
                @pageChange="pageChange"
            />
            <div class="linked-question-button">
                <RoundButton :text="cancelLabel" @btnClick="cancelClick" :cls="cancelCls" />
                <RoundButton :text="confirmLabel" :cls="confirmCls" :class="{'prohibit-submit':confirmCls == 'cancel-btn'}" @btnClick="confirmClick" />
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import RelationQuesBar from "./RelationQuesBar.vue"
import Table from "@/views/zhiji/bComponents/table/Table";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal.vue"
import i18n from "@/i18n";
import { quesListTable } from "./similarQuesConfig.js";
import { allSupportLangs } from "@/components/langSelect/languages.js";
import AssociateQuery from "./AssociateQuery";

export default {
    name: "CorrelateSimilarQuesModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        RelationQuesBar,
        Table,
        QuestionEditModal,
        AssociateQuery
    },
    data() {
        return {
            linkedQuestionId: "",
            currentId: "",
            currentVal: "",
            editVal: "",
            cancelCls: "cancel-btn",
            curPage: 1,
            curPageLen: quesListTable().pageLength,
            isBatchSimilar: this.data.similarNum, //false为单个相似问法
            defaultI18Lang: "",
            standTotal: "",
            tableData: [],
            requestObj: {}, //合并请求的参数
            batchRequestObj: {},
        };
    },
    computed: {
        confirmLabel() {
            return this.$t("zhiji.common.confirmRelation");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        tableConfig() {
            let data = quesListTable();
            data.columns.map(item=> item.colId == 'referQuestions' ? item.header = `${item.header} (${this.defaultI18Lang})` : null)
            return data;
        },
        confirmCls() {
            return this.linkedQuestionId ? "confirm-btn" : "cancel-btn"
        },
        currentLang() {
            return this.data.batchAssociationLang || this.data.currentLang || ""
        }
    },
    mounted() {
        this.getBusinessDefaultLang();
        window.document.addEventListener("click", this.windowClick);
        const { batchStandTotal, batchTableData, question: propQuesArr, requestObj } = this.data;
        if (this.isBatchSimilar === false) { // 单个问法的接口
            const clusterArr = this.$store.state.zhiji.questionCluster["conventionalData"].tableData.filter(item => item.rowId == propQuesArr[0].questionId);
            this.zhiji.requestByServiceName("searchQuestionOne",{
                question: propQuesArr[0].questionText,
                lang: clusterArr[0].selfLang,
            }).then(res => {
                this.tableData = res.dataset;
                this.standTotal = res.standTotal;
            });
        }
        if (batchStandTotal || batchStandTotal == 0) { //批量关联
            this.tableData = batchTableData;
            this.standTotal = batchStandTotal;
            this.batchRequestObj = requestObj;
        }
        this.currentLang && this.getBatchQuestionList({ lang: this.currentLang, page: 1 });
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        // 获取游戏业务的默认语言
        getBusinessDefaultLang() {
          const gameId = window.localStorage.getItem("gameId");
          const defaultLang =  this.$store.state.auth.businessSetting.robots.filter(item => item.gameId == gameId)[0].defaultLang;

          allSupportLangs.some((item) => {
            if (item.lang === defaultLang) {
              this.defaultI18Lang = i18n.t(item.i18nKey);
            }
          });
        },
        showTipsModal(message, type){
          this.$message({
              message: message,
              center: true,
              duration: 2000,
              type: type
          });
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        initCurrPage() {
            this.curPage = 1;
        },
        getBatchQuestionList(reqData) {
            this.requestObj = Object.assign({}, this.requestObj, this.batchRequestObj, reqData)
            this.zhiji.requestByServiceName("queryQuestionList", { ...this.requestObj, size: this.curPageLen }).then(res => {
              this.tableData = res.dataset;
              this.standTotal = res.standTotal;
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getBatchQuestionList({
                page: data.curPage,
                size: data.pageLength
            });
        },
        reqDataChange(data) {
            this.batchRequestObj = data;
        },
        tableColumnClick(data) {
            if (data.type == "RadioBox") {
                this.linkedQuestionId = data.rowData.rowId;
            } else if (data.colId === "standQuestion") {
              // 标准问题点击
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "AnswerPanel",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        closeHandler: () => {
                            this.getBatchQuestionList({
                                page: this.curPage,
                                size: this.curPageLen
                            });
                        }
                    }
                });
            }
        },
        emitEditEvent() {
            const newText = this.zhiji.strTrim(this.editVal);
            const isChanged = newText != this.currentVal;

            newText &&
                isChanged &&
                this.data.question.some(item => {
                    if (item.questionId === this.currentId) {
                        return (item.questionText = newText);
                    }
                });
            this.currentId = "";
        },
        confirmClick() {
            if (this.linkedQuestionId) {
                let questionArray = [];
                let questionIdArray = [];
                this.data.question.map(function(item) {
                    questionArray.push(item.questionText);
                    questionIdArray.push(item.questionId);
                });
                let configData = {};
                configData.questionArray = questionArray;
                configData.questionIdArray = questionIdArray;
                configData.clusterId = this.data.question[0].clusterId;
                configData.linkQuestionId = this.linkedQuestionId;

                this.data.confirm && this.data.confirm.call(null, configData);
                this.close();
                this.showTipsModal(this.$t("zhiji.common.addRelatedQuestion"), "success");
            } else {
                return;
            }
        },
        windowClick(event) {
            if (!!this.currentId && this.zhiji.isClickOuter(event, "scroll-tracker")) {
                this.emitEditEvent();
            }
        },
    }
};
</script>

<style lang="less" scoped>
.linked-question-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    /deep/.title-base-mask {
        max-height: none;
    }
    /deep/.base-content {
        padding: 10px;
    }
    /deep/.row-mask td .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    /deep/.row-mask td:nth-child(3) {
        overflow: visible;
        white-space: normal;
    }
    .linked-question-box {
      width: 980px;
      max-height: 97%;
    }
    .linked-question-button {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: -15px;
        .cancel-btn {
            background: #fff;
            box-sizing: border-box;
            padding: 0 3px;
            &:hover {
                color: rgba(65, 71, 94, 0.9) !important;
            }
        }
    }
    .prohibit-submit {
        cursor: not-allowed;
    }
    /deep/.table-wrapper .table {
        max-height: 500px;
    }
    /deep/.row-mask{
      height: 50px;
    }
}
</style>
